/**
 * Financial-year month helpers for dashboard charts.
 * Default FY start = April (4). Series stops at the current month (no future months).
 */

export const MONTH_SHORT = Object.freeze([
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
]);

export function currentFyStartYear(asOf = new Date(), startMonth = 4) {
  const sm = Math.min(12, Math.max(1, Number(startMonth) || 4));
  const y = asOf.getFullYear();
  const m = asOf.getMonth() + 1;
  if (sm === 1) return y;
  return m >= sm ? y : y - 1;
}

export function fyLabel(startYear, startMonth = 4) {
  const sm = Math.min(12, Math.max(1, Number(startMonth) || 4));
  if (sm === 1) return `${startYear}`;
  return `${startYear}-${String(startYear + 1).slice(-2)}`;
}

export function currentFyLabel(asOf = new Date(), startMonth = 4) {
  return fyLabel(currentFyStartYear(asOf, startMonth), startMonth);
}

/** FY months from start through current month only. */
export function buildFyMonthKeysThroughCurrent(startMonth = 4, asOf = new Date()) {
  const sm = Math.min(12, Math.max(1, Number(startMonth) || 4));
  const startYear = currentFyStartYear(asOf, sm);
  const cy = asOf.getFullYear();
  const cm = asOf.getMonth() + 1;
  const keys = [];
  for (let i = 0; i < 12; i += 1) {
    const monthNum = ((sm - 1 + i) % 12) + 1;
    let year = startYear;
    if (sm !== 1 && monthNum < sm) year = startYear + 1;
    if (year > cy || (year === cy && monthNum > cm)) break;
    keys.push({
      month: MONTH_SHORT[monthNum - 1],
      monthLabel: `${MONTH_SHORT[monthNum - 1]} '${String(year).slice(-2)}`,
      monthNum,
      year,
      key: `${year}-${String(monthNum).padStart(2, '0')}`,
    });
  }
  return keys;
}

/** Empty series (value 0) for FY start → current month — use when API has no trend yet. */
export function buildEmptyFySeries(valueField = 'value', startMonth = 4, asOf = new Date()) {
  return buildFyMonthKeysThroughCurrent(startMonth, asOf).map((m) => ({
    month: m.month,
    monthLabel: m.monthLabel,
    year: m.year,
    monthNum: m.monthNum,
    [valueField]: 0,
  }));
}
